'use strict';
Odigeo.defineWidget('ancillaries_debuginfo', Odigeo.Widget.extend({
    modelClass: require('./ancillaries_debuginfo.model'),
    viewClass: require('./ancillaries_debuginfo.view'),

    load: function() {
        this.model.refreshData();
    },
}));
